<template>
  <section v-editable="blok" class="grid-two-columns">
    <div>
      <div
        class="grid-two-columns__wrapper"
        :class="{ 'grid-two-columns--reverse': blok.reversed }"
      >
        <div
          class="grid-two-columns__description"
          :class="{ 'grid-two-columns__description--wider': blok.wider }"
        >
          <StoryblokComponent
            v-for="childBlok in blok.text_blocks"
            :key="childBlok._uid"
            :blok="childBlok"
          />
        </div>
        <div
          class="grid-two-columns__image-wrapper"
          :class="{
            'grid-two-columns__image-wrapper--reversed': blok.reversed,
          }"
        >
          <StoryblokComponent
            v-for="childBlok in blok.image_block"
            :key="childBlok._uid"
            :blok="childBlok"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { SbGridTwoColumnsStoryblok } from '@/types'
interface Props {
  blok: SbGridTwoColumnsStoryblok
}
defineProps<Props>()
</script>

<style lang="scss" scoped>
.grid-two-columns {
  &__wrapper {
    display: flex;
    flex-direction: column;

    @media (min-width: $breakpoint-lg) {
      flex-direction: row;
      justify-content: space-between;
    }
  }

  &__description {
    @media (min-width: $breakpoint-lg) {
      max-width: 50%;
      margin-bottom: 0;

      &--wider {
        max-width: 575px;
      }
    }
  }

  &__image-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 405px;
    margin: 0 auto;

    .fluid-image {
      display: block;
      margin: 0 auto;
      transform: translateX(-7.7%);
    }

    .button {
      display: block;
      margin: -14px auto 56px;
    }

    @media (min-width: $breakpoint-lg) {
      margin: 0;
      align-items: flex-end;
    }

    &--reversed {
      @media (min-width: $breakpoint-lg) {
        margin: 0;
        align-items: flex-start;
      }
    }
  }

  &--reverse {
    @media (min-width: $breakpoint-lg) {
      flex-direction: row-reverse;
    }
  }
}
</style>
